import { ThemeProvider } from "@mui/material/styles";
import { initializeApp } from "firebase/app";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import FAQ from "./app/FAQ";
import Promo from "./app/promo";
import UserProfilePage from "./app/Profile/UserProfile";
import ForgotPage from "./app/auth/forgot";
import ResetPasswordPage from "./app/auth/forgot/ResetPassword";
import LoginPage from "./app/auth/login";
import PrivacyPolicy from "./app/auth/PrivacyPolicy";
import Bookings from "./app/booking";
import JobsDetailForEach from "./app/booking/jobsDetails";
import JobSeekerDetails from "./app/booking/jobsDetails/jobSeekerDetails";
import JobSeekerProfile from "./app/booking/jobsDetails/jobSeekerProfile";
import Category from "./app/category";
import Chat from "./app/chat";
import ChatBooking from "./app/chatBooking";
import DashboardPage from "./app/dashboard";
import JobTitle from "./app/jobTitle";
import Notifications from "./app/notifications";
import Providers from "./app/providers";
import Setting from "./app/settings";
import Customer from "./app/users";
import { AuthProvider } from "./components/context/appContext";
import {
  AuthProtectedLayout,
  ProtectedLayout,
} from "./components/protectedLayout";
import MUI_THEME from "./theme";
import DeleteAccount from "./app/deleteAccount";
import CustomerSupport from "./app/customerSupport";
import AccountDeletion from "./app/customerSupport/AccountDeletion";
// import Chat from "./app/chat";

function App() {
  const firebaseConfig = {
    apiKey: "AIzaSyC6nKmA8eK5I6wrSwHnDOz0YtkUxBJQBKo",
    authDomain: "residentjob-4da34.firebaseapp.com",
    databaseURL: "https://residentjob-4da34-default-rtdb.firebaseio.com",
    projectId: "residentjob-4da34",
    storageBucket: "residentjob-4da34.firebasestorage.app",
    messagingSenderId: "1064475164652",
    appId: "1:1064475164652:web:85a1c4b2a6a71751d44ac9",
  };

  const app = initializeApp(firebaseConfig);
  return (
    <ThemeProvider theme={MUI_THEME}>
      <AuthProvider>
        <Routes>
          <Route element={<AuthProtectedLayout />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
          </Route>

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path={"/customer-support"} element={<CustomerSupport />} />
          <Route path={"/delete-account"} element={<AccountDeletion />} />

          <Route element={<ProtectedLayout />}>
            <Route path={"/"} element={<DashboardPage />} />
            <Route path={"/customer"} element={<Customer />} />
            <Route path={"/jobs"} element={<Bookings />} />
            <Route path={"/jobs-details/:id"} element={<JobsDetailForEach />} />
            <Route
              path={"/job-seeker-details/:id"}
              element={<JobSeekerProfile />}
            />

            <Route path={"/setting"} element={<Setting />} />

            <Route
              path={"/job-seeker-details"}
              element={<JobSeekerDetails />}
            />
            <Route path={"/profile"} element={<UserProfilePage />} />
            <Route path={"/providers"} element={<Providers />} />
            <Route path={"/category"} element={<Category />} />
            <Route path={"/job-title"} element={<JobTitle />} />
            <Route path={"/notifications"} element={<Notifications />} />
            <Route path={"/faq"} element={<FAQ />} />
            <Route path={"/promo"} element={<Promo />} />
            <Route path={"/chat-booking"} element={<ChatBooking />} />
            <Route path={"/chat"} element={<Chat />} />
          </Route>
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
